var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "personalise" }, [
    _c("div", { staticClass: "personalise__image" }, [
      _c("picture", [
        _c("img", {
          attrs: {
            src: `${_vm.addon.imageUrl}?format=webp`,
            alt: _vm.addon.name,
            loading: "lazy",
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "personalise__content" }, [
      _c("h3", [_vm._v(_vm._s(_vm.addon.name))]),
      _vm._v(" "),
      _vm.showFullText || _vm.addon.description.length <= this.exceptLength
        ? _c("p", { domProps: { innerHTML: _vm._s(_vm.addon.description) } })
        : _c("p", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$options.filters.truncate(
                  _vm.addon.description,
                  this.exceptLength,
                  "..."
                )
              ),
            },
          }),
      _vm._v(" "),
      _vm.addon.description.length > this.exceptLength
        ? _c(
            "div",
            {
              staticClass: "personalise__read",
              class: { "personalise__read--less": _vm.showFullText },
              attrs: {
                role: "button",
                tabindex: "0",
                "aria-expanded": _vm.showFullText,
                "aria-label": _vm.showFullText
                  ? _vm.data.readLessText
                  : _vm.data.readMoreText,
              },
              on: { click: _vm.toggleDescription },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.showFullText
                      ? _vm.data.readLessText
                      : _vm.data.readMoreText
                  ) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "personalise__footer" }, [
        _c("div", { staticClass: "personalise__price tour-price" }, [
          _c("div", { staticClass: "tour-price__days" }, [
            _c(
              "strong",
              {
                class: {
                  "tour-price__days_label":
                    _vm.brand === _vm.Brand.Travelsphere,
                },
              },
              [_vm._v(_vm._s(_vm.data.priceLabel))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tour-price__value" }, [
            _vm._v(_vm._s(_vm.addon.price)),
          ]),
        ]),
        _vm._v(" "),
        !_vm.isCheckoutPage
          ? _c("span", { staticClass: "personalise__message" }, [
              _vm._v(_vm._s(_vm.data.addAtCheckoutText)),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isCheckoutPage
        ? _c("div", { staticClass: "personalise__cta" }, [
            _c(
              "a",
              {
                staticClass: "btn personalise__cta-link",
                on: { click: _vm.bookExtension },
              },
              [_vm._v(_vm._s(_vm.checkoutData.addons.bookExtensionText))]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }